"use client";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listBlog } from "../../src/actions/blogAction.js";
import { seoData } from "../../src/fakeData/seoData.js";
import BlogCard from "../../src/components/blog/BlogCard.js";
import { Grid } from "@mui/material";
import Head from "next/head";
import { usePathname, useSearchParams } from "next/navigation";

const BlogPost = () => {
  const dispatch = useDispatch();
  const blogList = useSelector((state) => state.blogList);
  const { blog } = blogList;

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [canonicalUrl, setCanonicalUrl] = useState("");

  useEffect(() => {
    dispatch(listBlog());
  }, [dispatch]);

  useEffect(() => {
    const query = searchParams.toString();
    const fullUrl = `https://www.doortodoorbeauty.com${pathname}${
      query ? `?${query}` : ""
    }`;
    setCanonicalUrl(fullUrl);
  }, [pathname, searchParams]);

  const { title, description, keywords, author } = seoData.blog;

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentBlogPosts = blog?.result?.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil((blog?.result?.length || 0) / itemsPerPage);

  const handlePageChange = (pageNum) => {
    if (pageNum < 1) pageNum = 1;
    if (pageNum > totalPages) pageNum = totalPages;
    setCurrentPage(pageNum);
  };

  const getPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={author} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      </Head>

      <div className="bg-gray-50">
        <div
          className="flex justify-center py-10 lg:py-20 bg-indigo-100 w-full bg-cover bg-no-repeat bg-bottom"
          style={{ backgroundImage: `url('/assets/Blog/BlogHeader.jpg')` }}
        >
          <div className="flex mx-auto w-full max-w-screen-2xl px-3 sm:px-10">
            <div className="w-full flex justify-center flex-col relative">
              <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-serif text-center text-pink-600" style={{color: '#DB2777'}}>Blog</h1>
            </div>
          </div>
        </div>

        <div className="bg-white">
          <div className="max-w-screen-2xl mx-auto lg:py-20 py-10 px-4 sm:px-10">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 gap-y-8">
  {currentBlogPosts?.map((item, i) => (
    <div key={i} className="p-4">
      <BlogCard blog={item} />
    </div>
  ))}
</div>
            {/* Pagination */}
            <div
              className="paginationOrder flex justify-start mt-6"
              style={{ marginLeft: "18px" }}
            >
              <ul className="pagination flex space-x-2">
                <li className="page-item">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    className="bg-pink-600 hover:bg-emerald-600 border border-emerald-500 rounded py-2 px-4 text-sm text-white"
                    disabled={currentPage === 1}
                          style={{ borderRadius: '0.375rem', color: 'white' }} // 0.375rem = rounded-md

                  >
                    Previous
                  </button>
                </li>
                {getPageNumbers().map((page) => (
                  <li
                    key={page}
                    className={`page-item ${
                      currentPage === page ? "activePagination" : ""
                    }`}
                  >
                    <button
                      onClick={() => handlePageChange(page)}
                            style={{ borderRadius: '0.375rem', color: 'white' }} // 0.375rem = rounded-md

                      className="bg-pink-600 hover:bg-emerald-600 border border-emerald-500 rounded py-2 px-4 text-sm text-white"
                    >
                      {page}
                    </button>
                  </li>
                ))}
                <li className="page-item">
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    className="bg-pink-600 hover:bg-emerald-600 border border-emerald-500 rounded py-2 px-4 text-sm text-white"
                    disabled={currentPage === totalPages}
                          style={{ borderRadius: '0.375rem', color: 'white' }} // 0.375rem = rounded-md

                  >
                    Next
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogPost;
